import request from './httpService';

const submit = (data) => request({
  method: 'POST',
  url: '/feedback',
  data
});

export const FeedbackService = {
  submit
};